import React from 'react';
import SettingLinks from './SettingLinks';
 
 

const Settings = () => {
  return (
    <div className='lg:mt-16'>
      <SettingLinks/>
    </div>
  );
};

export default Settings;
